export default "__VITE_ASSET__CCE2TZP___"